import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { useAuth, authHeaders } from "../../lib/auth";
import OrderRow from "./OrderRow";

export default function OrdersList({ heading = "Dashboard", subtitle = "Your purchased services." }) {
  const { token } = useAuth();
  const [orders, setOrders] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get("/dashboard/orders", { headers: authHeaders(token) })
      .then((r) => setOrders(r.data))
      .catch(() => setError(true));
  }, [token]);

  return (
    <div className="px-6 md:px-12 py-12 md:py-16">
      <div className="max-w-5xl">
        <div className="text-[11px] tracking-[0.32em] uppercase text-[#2A5BFF] mb-4">Customer</div>
        <h1 className="font-anton uppercase text-5xl md:text-6xl leading-[0.9]" data-testid="dashboard-heading">{heading}</h1>
        <p className="mt-4 text-white/60 max-w-lg">{subtitle}</p>
      </div>

      <div className="max-w-5xl mt-10">
        {orders === null && !error && <div className="text-white/40 text-sm py-8" data-testid="orders-loading">Loading…</div>}
        {error && <div className="text-white/40 text-sm py-8" data-testid="orders-error">Couldn't load orders.</div>}
        {orders && orders.length === 0 && (
          <div className="border border-white/10 p-8 text-white/60" data-testid="orders-empty">
            No purchases yet. <Link to="/services" className="text-[#2A5BFF] hover:text-white">Browse services →</Link>
          </div>
        )}
        {orders && orders.length > 0 && (
          <div data-testid="orders-list">
            {orders.map((o) => <OrderRow key={o.id} order={o} />)}
          </div>
        )}
      </div>
    </div>
  );
}
